import React, { useRef } from 'react';

/* Número editable al estilo Tangle: se arrastra en horizontal (10px por paso)
   o se cambia con el teclado como un slider. */
export default function DragNum({ value, onChange, min, max, step = 1, label }) {
  const drag = useRef(null);
  const clamp = (v) => Math.min(max, Math.max(min, v));

  const onPointerDown = (e) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    drag.current = { x: e.clientX, v: value };
  };
  const onPointerMove = (e) => {
    if (!drag.current) return;
    const steps = Math.round((e.clientX - drag.current.x) / 10);
    onChange(clamp(drag.current.v + steps * step));
  };
  const onPointerUp = () => { drag.current = null; };
  const onKeyDown = (e) => {
    const map = {
      ArrowRight: step, ArrowUp: step, ArrowLeft: -step, ArrowDown: -step,
      PageUp: step * 10, PageDown: -step * 10,
    };
    if (e.key === 'Home') { e.preventDefault(); onChange(min); return; }
    if (e.key === 'End') { e.preventDefault(); onChange(max); return; }
    if (map[e.key] === undefined) return;
    e.preventDefault();
    onChange(clamp(value + map[e.key]));
  };

  return (
    <span
      className="drag"
      role="slider"
      tabIndex={0}
      aria-label={label}
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={value}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerUp}
      onKeyDown={onKeyDown}
    >
      {value}
    </span>
  );
}
